export default "__VITE_ASSET__Dhg37Nzx__"